import { config } from 'rebass';

const caps = {
  textTransform: 'uppercase',
  letterSpacing: '.2em',
};

export default {
  name: 'Dark',
  fontFamily: '"Avenir Next", Lato, Helvetica, sans-serif',
  color: '#eee',
  backgroundColor: '#111',
  borderRadius: 5,
  borderColor: `rgba(255, 255, 255, ${3 / 16})`,
  zIndex: [
    0,
    4,
    16,
    32,
    64,
  ],
  colors: {
    ...config.colors,
    blue: '#00d9f7',
    darkblue: '#01616f',
    purple: '#7a76ee',
    green: '#00ff88',
    orange: '#ffbb33',
    midgray: '#777788',
    gray: '#333339',
    red: '#ff5050',

    info: '#fb3',
    iconInfo: '#00d9f7',
    success: '#0f8',
    warning: '#fb3',
    primary: '#66666a',
    secondary: '#00d9f7',
    error: '#ff5050',

    class: {
      deathknight: '#c41f3b',
      'death knight': '#c41f3b',
      demonhunter: '#a330c9',
      'demon hunter': '#a330c9',
      druid: '#ff7d0a',
      hunter: '#abd473',
      mage: '#69ccf0',
      monk: '#00ff96',
      priest: '#ffffff',
      paladin: '#f58cba',
      rogue: '#fff569',
      shaman: '#0070de',
      warlock: '#9482c9',
      warrior: '#c79c6e',
    },
    items: {
      0: '#9d9d9d',
      1: '#ffffff',
      2: '#1eff00',
      3: '#0070dd',
      4: '#a335ee',
      5: '#ff8000',
      6: '#e6cc80',
      7: '#00ccff',
      8: '#00ccff',
      72: '#e6cc80',
    },

    // 8.3 colors
    corruption: '#956dd1',
    purify: '#fff100',
  },
  inverted: '#222222',

  scale: [
    0, 10, 20, 40, 80,
  ],

  Card: {
    backgroundColor: '#222222',
    border: 0,
  },
  Panel: {
    borderWidth: 2,
    backgroundColor: '#000000',
  },
  NavItem: {
    fontSize: 12,
    color: '#ffbb33',
    ...caps,
  },
  Heading: {
    ...caps,
  },
  Button: {
    ...caps,
    fontSize: 12,
    color: '#ffbb33',
    opacity: 7 / 8,
  },
  ButtonOutline: {
    ...caps,
    fontSize: 12,
    color: '#ffbb33',
    opacity: 7 / 8,
  },
  Toolbar: {
    minHeight: 64,
    color: '#ffbb33',
    backgroundColor: `rgba(0, 0, 0, ${7 / 8})`,
  },
  Label: {
    opacity: 5 / 8,
  },
  Menu: {
    color: '#ffbb33',
    backgroundColor: '#000',
  },
  Message: {
    color: '#111111',
    opacity: 15 / 16,
  },
  Text: {
    opacity: 7 / 8,
  },
  Footer: {
    opacity: 1 / 2,
  },
};
